import moment from 'moment'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import {
    ACCESS_SERVICES_MAP,
    APP_SERVICE,
    DELIVERY_TIME,
    FOOD_KIND,
    FOOD_TYPES,
    FULL_DATE_FORMAT,
    HAPPY_HOUR,
    ORDER_METHOD,
    TABLET_ORDER_METHOD,
    VALUE_TYPES,
} from '../constants'
import { ensureObject, ensureArray } from './helper'
import store from '../store'
import { getDayOfWeek } from './date'

const fpPromise = FingerprintJS.load();

// [ ...'0'.repeat(24) ].forEach((h, index) => {
//     [ 0, 15, 30, 45 ].forEach(m => {
//         list.push({ h: index, m })
//     })
// })

const times = [
    '00:00',
    '00:15',
    '00:30',
    '00:45',
    '01:00',
    '01:15',
    '01:30',
    '01:45',
    '02:00',
    '02:15',
    '02:30',
    '02:45',
    '03:00',
    '03:15',
    '03:30',
    '03:45',
    '04:00',
    '04:15',
    '04:30',
    '04:45',
    '05:00',
    '05:15',
    '05:30',
    '05:45',
    '06:00',
    '06:15',
    '06:30',
    '06:45',
    '07:00',
    '07:15',
    '07:30',
    '07:45',
    '08:00',
    '08:15',
    '08:30',
    '08:45',
    '09:00',
    '09:15',
    '09:30',
    '09:45',
    '10:00',
    '10:15',
    '10:30',
    '10:45',
    '11:00',
    '11:15',
    '11:30',
    '11:45',
    '12:00',
    '12:15',
    '12:30',
    '12:45',
    '13:00',
    '13:15',
    '13:30',
    '13:45',
    '14:00',
    '14:15',
    '14:30',
    '14:45',
    '15:00',
    '15:15',
    '15:30',
    '15:45',
    '16:00',
    '16:15',
    '16:30',
    '16:45',
    '17:00',
    '17:15',
    '17:30',
    '17:45',
    '18:00',
    '18:15',
    '18:30',
    '18:45',
    '19:00',
    '19:15',
    '19:30',
    '19:45',
    '20:00',
    '20:15',
    '20:30',
    '20:45',
    '21:00',
    '21:15',
    '21:30',
    '21:45',
    '22:00',
    '22:15',
    '22:30',
    '22:45',
    '23:00',
    '23:15',
    '23:30',
    '23:45',
]

export const formatCurrency = (money, group_separator = '.') =>
    (money + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + group_separator)

export const reMapBeilage = food => {
    const { beilageItems = [] } = food.foodDetails || {}
    if (!beilageItems.length) {
        return []
    }

    let toppingShow = []
    try {
        toppingShow = food.beilageItems
            .map((group, i) => {
                return (group || []).map((beilage, j) => {
                    if (beilage) {
                        return beilageItems?.[i]?.food_datas?.[j]
                    } else {
                        return null
                    }
                })
            })
            .reduce((rs, current) => [...rs, ...current], [])
            .filter(el => !!el)
    } catch (error) {
        console.log({ error })
    }
    return toppingShow
}

export const countAmountFromList = (foodList = []) =>
    foodList.reduce((sum, currentFood) => sum + currentFood.amount, 0)

export const runCustomTimer = (localTime = '', serverTime = '') => {
    console.log({ localTime, serverTime })
    const arrLocalTime = localTime.split('+')
    const arrServerTime = serverTime.split('+')
    // const mtLocalTime = moment(arrLocalTime[0].trim(), 'DD-MM-YYYY HH:mm:ss')
    const mtServerTime = moment(arrServerTime[0].trim(), 'DD-MM-YYYY HH:mm:ss')
    const deltalHour =
        (Number(arrLocalTime[1]) - Number(arrServerTime[1])) / 100
    window.appTimeInterval && clearInterval(window.appTimeInterval)
    window.appTime = moment(mtServerTime).add(deltalHour, 'h')
    window.appTimeInterval = setInterval(() => {
        window.appTime.add(1, 's')
    }, 1000)
    return true
}

export const checkInvalidRestaurant = (serverTime, extendDate) => {
    const serverTimeMoment = moment(serverTime, 'DD/MM/YYYY HH:mm:ss')
    const extendDateMoment = moment(extendDate, 'DD/MM/YYYY HH:mm:ss')
    if (!serverTimeMoment.isValid() || !extendDateMoment.isValid()) {
        return true
    }
    extendDateMoment.add(1, 'd')
    return serverTimeMoment - extendDateMoment > 0
}
//////////////////////////////////////////////////////////////////////////////////

const groupPriceOut = [ORDER_METHOD.PICKUP, ORDER_METHOD.DELIVERY]

// lấy giá món ăn
export const getFoodPrice = foodDetails => {
    const method =
        store.getState().OrderReducer.orderMethod || ORDER_METHOD.QR_CODE
    const tabletMethod = store.getState().OrderReducer.tabletForm?.orderMethod

    let price = ensureObject(foodDetails).price[method]

    if (groupPriceOut.includes(method) && price?.price) {
        return {
            price: price.price,
            saleOfPercent: price.sale_off_percent,
        }
    }

    price = ensureObject(foodDetails).price[ORDER_METHOD.QR_CODE]

    if (!price) {
        return {
            price: 0,
            saleOfPercent: 0,
        }
    }

    if (
        APP_SERVICE === ORDER_METHOD.TABLE_QRCODE &&
        method === ORDER_METHOD.TABLE_QRCODE &&
        tabletMethod === TABLET_ORDER_METHOD.TAKE_A_GO &&
        price.out_price
    ) {
        return {
            price: price.out_price,
            saleOfPercent: price.out_sale_off_percent,
        }
    }

    return {
        price: price.in_price,
        saleOfPercent: price.in_sale_off_percent,
    }
}

// làm tròn 2 chữ số, >= 0.5 làm tròn lên (bỏ sai số float)
export const roundMoney = (value = 0) =>
    Math.round(+(Number(value) * 100).toFixed(6)) / 100

export const calcPriceSale = (price = 0, percent = 0) =>
    roundMoney(price - ((price * percent) / 100))

// tính giá món ăn - sale - happly hour
// { currentPrice, originPrice }
export const getFoodPriceShow = foodDetails => {
    const { price, saleOfPercent } = getFoodPrice(foodDetails);

    const result = {
        currentPrice: price,
        saleOfPercent,
        isHappyHour: HAPPY_HOUR.NO
    }

    const happyHourPrice = getHappyHourPrice(foodDetails);
    if (happyHourPrice) {
        result.isHappyHour = HAPPY_HOUR.YES
        if (happyHourPrice.price_type === VALUE_TYPES.PERCENTAGE) {
            result.saleOfPercent = happyHourPrice.price || 0;
        } else {
            result.currentPrice = happyHourPrice.price || 0;
            result.saleOfPercent = 0;
        }
    }

    if (result.saleOfPercent) {
        result.currentPrice = calcPriceSale(result.currentPrice, result.saleOfPercent);
    }

    // Nếu giá sau khi giảm nhỏ hơn giá gốc => hiển thị originPrice
    if (Number(result.currentPrice) < Number(price)) {
        result.originPrice = price;
    }

    if (foodDetails?.currentPrice) {
        result.currentPrice = foodDetails?.currentPrice;
    }

    if (foodDetails?.saleOfPercent) {
        result.saleOfPercent = foodDetails?.saleOfPercent;
    }

    if (foodDetails?.isHappyHour !== undefined) {
        result.isHappyHour = foodDetails?.isHappyHour;
    }

    return result;
}

// tính tổng tiền 1 món ăn
export const calcMoneyFood = food => {
    try {
        const { foodDetails, amount = 0 } = food
        const beilageMap = reMapBeilage(food)
        const { currentPrice, originPrice, saleOfPercent, isHappyHour } =
            getFoodPriceShow(foodDetails)

        const price = foodDetails?.currentPrice || currentPrice

        const totalBeilage = beilageMap.reduce(
            (sum, tp) => sum + Number(tp.price),
            0
        )
        const total = (price + totalBeilage) * amount
        const originTotal = ((originPrice || price) + totalBeilage) * amount

        return {
            total,
            originTotal,
            currentPrice: price,
            originPrice,
            saleOfPercent,
            isHappyHour,
        }
    } catch (error) {
        return {}
    }
}

export const calcMoneyFoodList = foodList =>
    foodList.reduce(
        (sum, current) => {
            const { total, originTotal } = calcMoneyFood(current)
            sum.total = roundMoney(sum.total + total)
            sum.originTotal = roundMoney(sum.originTotal + originTotal)
            return sum
        },
        { total: 0, originTotal: 0 }
    )

const getFoodType = () => {
    if (APP_SERVICE === ORDER_METHOD.QR_CODE) {
        return FOOD_TYPES.FOOD_TYPE_IN;
    }

    if (APP_SERVICE === ORDER_METHOD.TABLE_QRCODE) {
        const orderMethod = store.getState().OrderReducer?.tabletForm?.orderMethod;
        return orderMethod === TABLET_ORDER_METHOD.AT_RES ? FOOD_TYPES.FOOD_TYPE_IN : FOOD_TYPES.FOOD_TYPE_OUT;
    }

    const orderMethod = store.getState().OrderReducer?.orderMethod;
    return orderMethod === ORDER_METHOD.PICKUP ? FOOD_TYPES.FOOD_TYPE_PICKUP : FOOD_TYPES.FOOD_TYPE_DELIVER;
}

/* map lại danh sách món ăn để submit */
export const remapFoodToAdd = (foods, currentcy, customerPosition) => {
    return ensureArray(foods).map(food => {
        const { foodDetails, vat, note, amount, groupOrder, printerIp } = food
        const { name, plu, systemPosPlu, foodParent, printers } = foodDetails
        const { currentPrice, saleOfPercent, isHappyHour } = getFoodPriceShow(foodDetails)
        const { price: originalPrice } = getFoodPrice(foodDetails)
        const beilageMapped = reMapBeilage(food)
        const type = getFoodType();

        return {
            systemPlu: systemPosPlu,
            groupOrder,
            note,
            amount,
            vat,
            type,
            ordering: 1,
            name,
            parentName: foodParent?.kind === FOOD_KIND.FOOD_SUBS ? foodParent?.name : undefined,
            plu,
            price: currentPrice,
            priceUnit: currentcy,
            customerNo: customerPosition,
            originalPrice,
            saleOfPercent,
            additionFoods: beilageMapped.map(({ name_food, price, plu }) => ({
                name: name_food,
                price,
                plu
            })),
            printerIp,
            printerSetting: printers,
            isHappyHour,
        }
    });
}

/* Chuyển đổi food thành string để so sánh */
export const getStringFromFood = food => {
    const { foodDetails } = food
    const beilageArr = reMapBeilage(food)
    return [
        foodDetails?.plu,
        foodDetails?.saleOfPercent,
        foodDetails?.currentPrice,
        ...beilageArr.map(el => el.name_food + ' ' + el.price),
        food.vat,
        food.note,
        food.groupOrder,
    ]
        .join(' ')
        .replace(/ /g, '+')
        .trim()
}

const getHappyHourByMethod = (foodDetails, orderMethod, tabletOrderMethod) => {
    const { happyHoursSetting } = foodDetails;
    let method = orderMethod;

    if (orderMethod === ORDER_METHOD.QR_CODE) {
        method = 'qrcode_in';
    }

    if (orderMethod === ORDER_METHOD.TABLE_QRCODE) {
        method = tabletOrderMethod === TABLET_ORDER_METHOD.AT_RES ? 'qrcode_in' : 'qrcode_out';
    }

    return happyHoursSetting[method];
}

/*  */
export const getHappyHourPrice = (foodDetails = {}) => {
    const listHappyHour = store.getState().RestaurantReducer?.settings?.happy_hours_settings || {};
    const tabletOrderMethod = store.getState().OrderReducer.tabletForm?.orderMethod;
    const orderMethod = store.getState().OrderReducer.orderMethod;

    const happyHoursSetting = getHappyHourByMethod(foodDetails, orderMethod, tabletOrderMethod);
    if (!happyHoursSetting) {
        return null;
    }

    const mapFrame = happyHoursSetting
        .map(frame => {
            const fullFrameData = listHappyHour[frame.time_frame]
            return fullFrameData
                ? { ...fullFrameData, ...frame }
                : undefined
        })
        .filter(f => !!f)

    const time = window.appTime;
    // moment().day() => day of week => from 0-6 with 0 is sunday
    // time_of_weeks => setting day from 0-6 with 0 is monday
    const day = (time.day() || 7) - 1;
    return mapFrame.find(f => {
        const { time_of_weeks, from, to } = f
        const fromTime = moment(time).hour(from.hour).minute(from.minute)
        const toTime = moment(time).hour(to.hour).minute(to.minute)
        return (
            time_of_weeks[day] &&
            time.isBetween(fromTime, toTime, undefined, '[]')
        )
    })
}

export const runAppTimer = (timezone = '', serverTime = '') => {
    window.appTimeInterval && clearInterval(window.appTimeInterval)
    window.appTime = moment(serverTime, FULL_DATE_FORMAT).add(
        Number(timezone.replace(':', '.')),
        'h'
    )

    const startTime = new Date()
    const startMoment = moment(window.appTime)
    document.addEventListener('visibilitychange', () => {
        if ('visible' === document.visibilityState) {
            const delta = new Date() - startTime
            window.appTime = moment(startMoment).add(delta, 'ms')
        }
    })

    window.appTimeInterval = setInterval(() => {
        window.appTime.add(1, 's')
        // console.warn(window.appTime.toString())
    }, 1000)
    return true
}

export const convertServerTime = serverTime => {
    const { timezone = '' } = store.getState().RestaurantReducer.settings || {}

    const realTime = moment(serverTime, FULL_DATE_FORMAT)

    if (!timezone) {
        return realTime
    }

    const { offset } = timezone
    realTime.add(Number(offset.replace(':', '.')), 'h')

    return realTime
}

const offsetString = s => ('00' + s).slice(-2)

export const formatTimeFromMillisecond = millisecond => {
    const second = millisecond / 1000
    let hrs = ~~(second / 3600)
    let mins = ~~((second % 3600) / 60)
    let secs = ~~second % 60

    return [offsetString(hrs), offsetString(mins), offsetString(secs)].join(':')
}

export const getRealTime = time => {
    const { timezone } = store.getState().RestaurantReducer.settings || {}

    if (!timezone) {
        return time
    }

    const { offset } = timezone
    const timeMoment = moment(time, FULL_DATE_FORMAT).add(
        Number(offset.replace(':', '.')),
        'h'
    )

    return timeMoment.format(FULL_DATE_FORMAT)
}

export const getRealMomentTimeFromHour = time => {
    // const { timezone } = store.getState().RestaurantReducer.settings || {}

    // if (!timezone) {
    //     return time
    // }

    // const { offset } = timezone
    const [hour, minutes] = time.split(':')
    const timeMoment = moment(window.appTime)
    timeMoment.set('h', hour)
    timeMoment.set('m', minutes)
    // timeMoment.add(Number(offset.replace(':', '.')), 'h')

    return timeMoment
}

export const checkTimeCanAddFood = f => {
    const { timeFrom, timeEnd, settings } = f;
    let timeOffs = [];
    try {
        timeOffs = JSON.parse(settings || "{}").timeOffs || [];
    } catch (ignore) {}

    const currentDayOfWeek = getDayOfWeek(window.appTime);
    if (!!timeOffs[currentDayOfWeek]) {
        return false;
    }

    if (timeFrom && timeEnd) {
        return window.appTime.isBetween(
            getRealMomentTimeFromHour(timeFrom),
            getRealMomentTimeFromHour(timeEnd),
            undefined,
            '[]'
        )
    }

    if (timeFrom) {
        return window.appTime > getRealMomentTimeFromHour(timeFrom)
    }

    if (timeEnd) {
        return window.appTime < getRealMomentTimeFromHour(timeEnd)
    }

    return true
}

/* Lấy phút của giờ hiện tại */
export const minutesOfDay = m => {
    return m.minutes() + m.hours() * 60
}

export const isOrderAtRestaurant = method =>
    [ORDER_METHOD.QR_CODE, ORDER_METHOD.TABLE_QRCODE].includes(method)

export const getOffsetTop = elem => {
    var offsetTop = 0
    do {
        if (!isNaN(elem.offsetTop)) {
            offsetTop += elem.offsetTop
        }
    } while ((elem = elem.offsetParent))
    return offsetTop
}

export const checkCanFastAdd = f => !f?.beilageItems?.length && !f?.subs

export const isAppleDevice = () =>
    /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)

const dayOfWeekMap = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
]

const getTimeFromStringMinute = minutes => {
    const [hour, minute] = minutes.split(':')
    return moment(window.appTime).set('h', hour).set('m', minute)
}

export const getTodayTimework = () => {
    const timeSettings =
        store.getState().RestaurantReducer?.settings?.time_work || store.getState().RestaurantReducer?.settings?.general_time_work || {}

    const todayStr = window.appTime.format('DD/MM');
    if (Array.isArray(timeSettings.dayOffs) && timeSettings.dayOffs.includes(todayStr)) {
        return [];
    }

    let todayTimeWork = timeSettings[dayOfWeekMap[window.appTime.day()]] || []
    return todayTimeWork
}

export const checkInFrameOpen = frameTime => {
    const [start, end] = frameTime.split('-')
    return window.appTime.isBetween(
        getTimeFromStringMinute(start),
        getTimeFromStringMinute(end),
        undefined,
        '[]'
    )
}

export const getInFrameOpen = () => getTodayTimework().find(checkInFrameOpen)

export const checkOverTime = () => {
    if (APP_SERVICE !== ACCESS_SERVICES_MAP.WEB) {
        return false
    }

    try {
        const todayTimeWork = getTodayTimework()

        return !todayTimeWork.some(checkInFrameOpen)
    } catch (error) {
        return true
    }
}

export const getDeliveryTime = () => {
    const { tablet_min_time_complete_online = 45 } =
    store.getState().RestaurantReducer?.settings || {}

    const todayTimeWork = getTodayTimework()
        .filter(time => time !== '00:00-00:00')
        .map(time => {
            const [ start, end ] = time.split('-')

            const startMoment = getTimeFromStringMinute(start).add(tablet_min_time_complete_online, 'm')
            const endMoment = getTimeFromStringMinute(end)
            const minTime = moment(window.appTime).add(tablet_min_time_complete_online, 'm')

            if (endMoment.isBefore(minTime)) {
                return []
            }

            return [
                startMoment.isBefore(minTime)
                    ? minTime
                    : startMoment,
                endMoment,
            ]
        })
        .filter(time => !!time.length)

    return [
        DELIVERY_TIME,
        ...times.filter(t => todayTimeWork.some(([ start, end]) => getTimeFromStringMinute(t).isBetween(
            start,
            end,
            undefined,
            '[)'
        ))
        ),
    ]
}

export const formatMoney = money => {
    const {
        currentcy = '',
        decimal_separator = ',',
        group_separator = '.',
    } = store.getState().RestaurantReducer?.settings || {};

    const validMoney = isNaN(Number(money)) ? 0 : Number(money)
    return formatCurrency(
        (roundMoney(validMoney).toFixed(2) + '').replace(/\./g, decimal_separator),
        group_separator
    ) + ' ' + currentcy;
}

export const getDisplayFoodName = food => {
    if (!food) {
        return '';
    }

    const { name, parentName, foodParent } = food;

    return [
        parentName || (foodParent?.kind === FOOD_KIND.FOOD_SUBS && foodParent?.name),
        name
    ].filter(Boolean).join('\n');
}

export const getFingerId = async () => {
    const fp = await fpPromise
    const result = await fp.get()

    return result.visitorId;
}

export const validFoodDataFromServer = (foodData, customerPosition) => {
    return ensureArray(foodData)
        .filter(f => f.customerNo === customerPosition)
        .map(el => ({ ...el, submitted: true }));
}

export const getPrinterByIndex = index => {
    const { printers = [] } = store.getState().RestaurantReducer?.settings || {};
    return printers.find(printer => printer.number === index);
}

export const makeAddressCalcDistance = (street, addressNumber, city, postcode) => {
    // const { region_google } = store.getState().RestaurantReducer?.settings?.deliver_setting || {};
    return `${street} ${addressNumber},${postcode || ''} ${city}`;
}

export const findAddressFromAddressComponents = (addressComponents, key) =>
    addressComponents.find(component => component.types?.includes(key))
        ?.long_name

export const getUserAddressFromAddressComp = addressComponents => {
    const userCity = findAddressFromAddressComponents(
        addressComponents,
        'locality'
    )
    const userPostcode = findAddressFromAddressComponents(
        addressComponents,
        'postal_code'
    )
    const userStreet = findAddressFromAddressComponents(
        addressComponents,
        'route'
    )
    const userAddressNumber = [
        findAddressFromAddressComponents(
            addressComponents,
            'street_number'
        ),
        findAddressFromAddressComponents(
            addressComponents,
            'subpremise'
        ),
    ]
        .filter(Boolean)
        .join('/');

    return { userCity, userPostcode, userStreet, userAddressNumber };
}
